"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const constants_1 = require("./constants");
let PaginationArgs = class PaginationArgs {
    constructor() {
        this.skip = 0;
        this.take = 20;
        this.page = 1;
        this.pageSize = 20;
        this.orderBy = 'updatedAt';
        this.orderDir = constants_1.DESC;
        this.archived = false;
        this.searchQuery = null;
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.Int, { nullable: true }),
    class_validator_1.Min(0),
    tslib_1.__metadata("design:type", Number)
], PaginationArgs.prototype, "skip", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.Int, { nullable: true }),
    class_validator_1.Min(1),
    class_validator_1.Max(120),
    tslib_1.__metadata("design:type", Number)
], PaginationArgs.prototype, "take", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.Int, { nullable: true }),
    class_validator_1.Min(1),
    tslib_1.__metadata("design:type", Number)
], PaginationArgs.prototype, "page", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.Int, { nullable: true }),
    class_validator_1.Min(1),
    class_validator_1.Max(120),
    tslib_1.__metadata("design:type", Number)
], PaginationArgs.prototype, "pageSize", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", String)
], PaginationArgs.prototype, "orderBy", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsIn([constants_1.DESC, constants_1.ASC]),
    tslib_1.__metadata("design:type", String)
], PaginationArgs.prototype, "orderDir", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], PaginationArgs.prototype, "archived", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], PaginationArgs.prototype, "searchQuery", void 0);
PaginationArgs = tslib_1.__decorate([
    type_graphql_1.ArgsType(),
    type_graphql_1.InputType()
], PaginationArgs);
exports.PaginationArgs = PaginationArgs;
//# sourceMappingURL=PaginationArgs.js.map